import { FC, useRef } from "react";
import Popup from "reactjs-popup";
import { t } from "i18next";
import ArrowCancelSVG from "../../custom-components/svg/functional-icons/ArrowCancelSVG";
import DeleteButtonSVG from "../../custom-components/svg/functional-icons/DeleteButtonSVG";
import DownloadDataSVG from "../../custom-components/svg/functional-icons/DownloadData";

interface EditUserPhotoModelProps {
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
    deleteHandler?: () => void;
    imageUrl: string | null;
    onChange: (files: File[] | null) => void;
}

const EditUserPhotoModel: FC<EditUserPhotoModelProps> = (props) => {
    const openHandler = () => {
    };
    const closeHandler = () => {
        props.setIsVisible(false);
    };
    const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        props.onChange([file]);
        closeHandler();
    };
    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
        <>
            <Popup
                onOpen={openHandler}
                open={props.isVisible}
                modal
                overlayStyle={{ zIndex: 99999, backgroundColor: "#0A2C5CCC " }}
                onClose={closeHandler}
            >
                <div
                    id="static-modal"
                    data-modal-backdrop="static"
                    className={`lg:w-[500px] lg:h-[325px] md:w-[400px] md:h-[270px] overflow-y-auto overflow-x-hidden justify-center items-center`}
                >
                    <div className="relative px-4 w-full max-h-full p-4">
                        <div className={`relative bg-white rounded-sm shadow`}>
                            <div className="lg:px-4 lg:py-10 md:px-2 md:py-8">
                                <div className="flex flex-col justify-center gap-3 p-4 rounded-b">
                                    <input
                                        id="image-upload"
                                        type="file"
                                        ref={inputRef}
                                        accept="image/jpeg,image/png,image/webp,image/svg+xml"
                                        onChange={handleImageChange}
                                        className="sr-only"
                                    />
                                    <button
                                        data-modal-hide="static-modal"
                                        type="button"
                                        className={
                                            "uppercase flex items-center text-left hover:bg-gray-100 font-medium text-xl px-3 py-2.5 "
                                        }
                                        onClick={() => inputRef.current?.click()}
                                    >
                                        <span className="mr-3"><DownloadDataSVG iconColor="#4771FE" /></span>
                                            {t("account.buttonText.uploadPhoto")}
                                    </button>
                                    <button
                                        data-modal-hide="static-modal"
                                        type="button"
                                        className="uppercase flex items-center text-left hover:bg-gray-100 font-medium text-xl px-3 py-2.5"
                                        onClick={() => {
                                            props.deleteHandler?.();
                                            closeHandler();
                                        }}
                                    >
                                        <span className="mr-3"><DeleteButtonSVG iconColor="#BD0427" /></span>
                                        {t("account.buttonText.deletePhoto")}
                                    </button>
                                    <button
                                        type="button"
                                        className="flex items-center justify-between uppercase bg-text-300 text-background-100 py-3 px-6 text-sm rounded"
                                        data-modal-hide="static-modal"
                                        onClick={closeHandler}
                                    >
                                        <span>{t("account.buttonText.cancelSaving")}</span>
                                        <ArrowCancelSVG />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </Popup >
        </>
    );
};

export default EditUserPhotoModel;
